import React from 'react';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';

const Terms = () => {
  return (
    <div className="pt-20" data-testid="terms-page">
      {/* Hero Section */}
      <section className="py-16 md:py-20 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <FileText className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold">
              Terms & Conditions
            </h1>
            <p className="mt-4 text-slate-300">Lane 4 For All Kids Foundation</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate prose-lg">
          <p className="text-slate-600"><strong>Effective Date:</strong> January 2026</p>

          <p>Welcome to the website of Lane 4 For All Kids Foundation ("Foundation," "we," "our," or "us"). By accessing or using our website, you agree to comply with and be bound by the following Terms and Conditions. If you do not agree with these terms, please do not use this website.</p>

          <h2 className="font-heading">1. Use of Website</h2>
          <p>The content on this website is provided for general information about Lane 4 For All Kids Foundation and our programs. You agree to use the website only for lawful purposes and in a way that does not infringe upon the rights of others or restrict their use of the website. You may not:</p>
          <ul>
            <li>Use the website for fraudulent or unlawful purposes</li>
            <li>Attempt to gain unauthorized access to website systems</li>
            <li>Interfere with website security or functionality</li>
            <li>Use the website to transmit harmful software or malware</li>
          </ul>

          <h2 className="font-heading">2. Donations</h2>
          <p>Lane 4 For All Kids Foundation accepts voluntary donations to support our programs and initiatives. All donations are final unless an error occurs during the transaction. If you believe a donation was made in error, please contact us within a reasonable time for assistance. Online donations may be processed through secure third-party payment processors such as Stripe. Lane 4 For All Kids Foundation does not store or retain full credit card information.</p>

          <h2 className="font-heading">3. Tax Status Notice</h2>
          <p>Lane 4 For All Kids Foundation is currently in the process of obtaining 501(c)(3) tax-exempt status from the Internal Revenue Service. At this time, donations may not be tax-deductible. If tax-exempt status is approved, donations may become deductible to the extent permitted by law.</p>

          <h2 className="font-heading">4. Intellectual Property</h2>
          <p>All content on this website, including but not limited to:</p>
          <ul>
            <li>Text</li>
            <li>Graphics</li>
            <li>Logos</li>
            <li>Images</li>
            <li>Videos</li>
            <li>Website design</li>
          </ul>
          <p>is the property of Lane 4 For All Kids Foundation unless otherwise noted and is protected by applicable copyright and intellectual property laws. Content may not be copied, reproduced, or distributed without prior written permission.</p>

          <h2 className="font-heading">5. Third-Party Links</h2>
          <p>Our website may contain links to third-party websites or services. These links are provided for convenience only. Lane 4 For All Kids Foundation does not control or endorse these websites and is not responsible for their content, policies, or practices.</p>

          <h2 className="font-heading">6. Limitation of Liability</h2>
          <p>Lane 4 For All Kids Foundation makes reasonable efforts to ensure that information on this website is accurate and current. However, we do not guarantee that all content is free from errors. To the fullest extent permitted by law, Lane 4 For All Kids Foundation shall not be liable for any damages arising from the use of this website.</p>

          <h2 className="font-heading">7. Website Availability</h2>
          <p>We strive to maintain continuous access to our website but cannot guarantee uninterrupted availability. The website may be temporarily unavailable due to maintenance or technical issues.</p>

          <h2 className="font-heading">8. Privacy</h2>
          <p>Your use of this website is also governed by our Privacy Policy, which explains how we collect, use, and protect your personal information.</p>

          <h2 className="font-heading">9. Changes to These Terms</h2>
          <p>Lane 4 For All Kids Foundation may update these Terms and Conditions at any time. Updates will be posted on this page with a revised effective date. Continued use of the website after changes indicates acceptance of the updated terms.</p>

          <h2 className="font-heading">10. Contact Information</h2>
          <p>If you have questions regarding these Terms and Conditions, please contact us:</p>
          <p>
            <strong>Lane 4 For All Kids Foundation</strong><br />
            Email: info@lane4foundation.com<br />
            Phone: 877.495.2634
          </p>
        </div>
      </section>
    </div>
  );
};

export default Terms;
